<div class="bg-primary-50 relative flex h-full w-full flex-col items-center justify-center gap-5">
  <img src="assets/images/logo/logo-subtle.svg" alt="Comex McKinnon" class="absolute top-10" />
  <img
    src="assets/images/logo/logo-icon-subtle.svg"
    alt="Comex McKinnon Icon"
    class="absolute bottom-0 z-0"
  />

  @if (information().details) {
    @let details = information().details!;
    <div class="z-10 flex flex-col items-center gap-2.5">
      <i-lucide [img]="details.icon" class="text-primary-400 size-16" />
      <h1 class="text-primary-600 text-center font-semibold">
        {{ details.summary }}
      </h1>
    </div>
  } @else if (information().error) {
    @let error = information().error!;
    <div class="z-10 flex flex-col items-center gap-2.5">
      <h1 class="text-primary-600 text-center font-semibold">
        {{ error.summary }}
      </h1>
      <p class="text-primary-400 text-[4.375rem] leading-17.5 font-extrabold">
        {{ error.code }}
      </p>
    </div>
  }

  <hr class="text-primary-300 z-10 w-75" />

  @if (information().message) {
    <p class="text-primary-800 z-10 text-center text-lg" [innerHTML]="information().message"></p>
  }

  @if (information().action) {
    @let action = information().action!;
    <p-button
      class="z-10 mt-5"
      size="small"
      [label]="action.label"
      (onClick)="action.callback?.()"
      [routerLink]="action.route"
    />
  }
</div>
